module.exports = __webpack_public_path__ + "static/media/img21.682e3f05.jpg";